var _rect, _text, _text2, _text3, _text4, _line, _path, _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase3Fig1FiveGenerations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1280 500",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1280,
    height: 500,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Five rebuilds, each answering a measured failure")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "June to July 2026. Each transition carries the measured failure that forced the rebuild; below each shape, what it delivered")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 128,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#DC2626",
    fontWeight: 600
  }, "WHAT FAILED, MEASURED")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 392,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#16A34A",
    fontWeight: 600
  }, "WHAT THE REBUILD PRODUCED")), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 60,
    y1: 300,
    x2: 1232,
    y2: 300,
    stroke: "#D4DDD6",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1232 294 l12 6 l-12 6 z",
    fill: "#D4DDD6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 13.5,
    fontWeight: 600,
    fill: "#1A2F2A",
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 297
  }, "Oracle everything"), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "06-19"), /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 297
  }, "One agent per book"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "06-20"), /*#__PURE__*/React.createElement("rect", {
    x: 444,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 297
  }, "Bulk integration"), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "06-21"), /*#__PURE__*/React.createElement("rect", {
    x: 636,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 297
  }, "Corrective mine"), /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "06-23"), /*#__PURE__*/React.createElement("rect", {
    x: 828,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 297
  }, "Productized skills"), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "06-30"), /*#__PURE__*/React.createElement("rect", {
    x: 1020,
    y: 272,
    width: 176,
    height: 56,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 1108,
    y: 297
  }, "Re-authoring"), /*#__PURE__*/React.createElement("text", {
    x: 1108,
    y: 316,
    fontSize: 11.5,
    fontWeight: 400,
    fill: "#6B7F74"
  }, "07-08"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 244,
    y1: 294,
    x2: 244,
    y2: 228,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 180,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "206 agents, 6.7M tokens"), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 198,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "into a usage cap, then a"), /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 216,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "one-agent fan-in stall"), /*#__PURE__*/React.createElement("line", {
    x1: 436,
    y1: 294,
    x2: 436,
    y2: 228,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 436,
    y: 198,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "agents editing files"), /*#__PURE__*/React.createElement("text", {
    x: 436,
    y: 216,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "could not be trusted"), /*#__PURE__*/React.createElement("line", {
    x1: 628,
    y1: 294,
    x2: 628,
    y2: 228,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 198,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "an entire content tier"), /*#__PURE__*/React.createElement("text", {
    x: 628,
    y: 216,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "was mined at zero"), /*#__PURE__*/React.createElement("line", {
    x1: 820,
    y1: 294,
    x2: 820,
    y2: 228,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 198,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "a many-step manual"), /*#__PURE__*/React.createElement("text", {
    x: 820,
    y: 216,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "flow was unrepeatable"), /*#__PURE__*/React.createElement("line", {
    x1: 1012,
    y1: 294,
    x2: 1012,
    y2: 228,
    stroke: "#DC2626",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1012,
    y: 180,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "3 red and 14 yellow"), /*#__PURE__*/React.createElement("text", {
    x: 1012,
    y: 198,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "of 17 audited, and"), /*#__PURE__*/React.createElement("text", {
    x: 1012,
    y: 216,
    textAnchor: "middle",
    fill: "#1A2F2A",
    fontWeight: 500
  }, "zero clean"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#4A5F56"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 328,
    x2: 148,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 424,
    textAnchor: "middle"
  }, "the doctrine reset:"), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 442,
    textAnchor: "middle"
  }, "mine broad,"), /*#__PURE__*/React.createElement("text", {
    x: 148,
    y: 460,
    textAnchor: "middle"
  }, "integrate selective"), /*#__PURE__*/React.createElement("line", {
    x1: 340,
    y1: 328,
    x2: 340,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 424,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#16A34A"
  }, "124 designs from"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 442,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#16A34A"
  }, "12 agents, 851K"), /*#__PURE__*/React.createElement("text", {
    x: 340,
    y: 460,
    textAnchor: "middle"
  }, "tokens, ~6 minutes"), /*#__PURE__*/React.createElement("line", {
    x1: 532,
    y1: 328,
    x2: 532,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 424,
    textAnchor: "middle"
  }, "agents author data,"), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 442,
    textAnchor: "middle"
  }, "the loop writes the"), /*#__PURE__*/React.createElement("text", {
    x: 532,
    y: 460,
    textAnchor: "middle"
  }, "files, alone"), /*#__PURE__*/React.createElement("line", {
    x1: 724,
    y1: 328,
    x2: 724,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 424,
    textAnchor: "middle",
    fontWeight: 600,
    fill: "#16A34A"
  }, "3,078 units mined"), /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 442,
    textAnchor: "middle"
  }, "across the full"), /*#__PURE__*/React.createElement("text", {
    x: 724,
    y: 460,
    textAnchor: "middle"
  }, "content-type ladder"), /*#__PURE__*/React.createElement("line", {
    x1: 916,
    y1: 328,
    x2: 916,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 424,
    textAnchor: "middle"
  }, "one command, cost"), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 442,
    textAnchor: "middle"
  }, "bounded, stopping at"), /*#__PURE__*/React.createElement("text", {
    x: 916,
    y: 460,
    textAnchor: "middle"
  }, "a founder greenlight"), /*#__PURE__*/React.createElement("line", {
    x1: 1108,
    y1: 328,
    x2: 1108,
    y2: 352,
    stroke: "#16A34A",
    strokeWidth: 1.5,
    strokeDasharray: "3 3"
  }), /*#__PURE__*/React.createElement("text", {
    x: 1108,
    y: 424,
    textAnchor: "middle"
  }, "defective plays"), /*#__PURE__*/React.createElement("text", {
    x: 1108,
    y: 442,
    textAnchor: "middle"
  }, "repaired in place at"), /*#__PURE__*/React.createElement("text", {
    x: 1108,
    y: 460,
    textAnchor: "middle"
  }, "a locked role tier"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase3Fig1FiveGenerations);
export default __webpack_public_path__ + "static/media/case3-fig1-five-generations.7dfa0db1da8e26b1dd2da62614b8388c.svg";
export { ForwardRef as ReactComponent };